import React from 'react'
import PropTypes from 'prop-types'
import { Select } from 'semantic-ui-react'
import InputNumber from 'components/inputs/InputNumber'
import './style.css'

const select_options = [
  {
    key: 'weekly',
    value: 'weekly',
    text: 'Weekly',
  },{
    key: 'bi-weekly',
    value: 'bi-weekly',
    text: 'Bi-weekly',
  },{
    key: 'semi-monthly',
    value: 'semi-monthly',
    text: 'Semi-monthly',
  },{
    key: 'monthly',
    value: 'monthly',
    text: 'Monthly',
  },{
    key: 'annually',
    value: 'annually',
    text: 'Annually',
  }
]

const limited_options = [
  {
    key: 'monthly',
    value: 'monthly',
    text: 'Monthly',
  },{
    key: 'annually',
    value: 'annually',
    text: 'Annually',
  }
]
class InputNumberFrequency extends React.Component{
  constructor(props) {
    super(props)

    this.state = {
      num: this.props.numValue || null,
      freq: this.props.freqValue || null,
    };
  }

  onChange = (e, h) => {
    const name = h.name === 'num' ? this.props.inputNumberName : this.props.inputFreqName
    this.setState({ [h.name]: h.value })
    this.props.onChange({
      target:{
        name,
        value: h.value
      }
    })
  }

  componentDidUpdate(prevProps) {
    if (prevProps.numValue !== this.props.numValue) {
      this.setState({ num: this.props.numValue }) 
    }
    if (prevProps.freqValue !== this.props.freqValue) {
      this.setState({ freq: this.props.freqValue }) 
    }
  }
  
  render() {
    const { num, freq } = this.state
    const { disabled, freqDisabled, width, style } = this.props

    return (
      <div className="input-number-freq-wrapper" style={style}>
        <InputNumber width={width} disabled={disabled} name='num' value={num} onChange={this.onChange}/>
        <Select name='freq' value={freqDisabled ? 'monthly' : freq} disabled={freqDisabled || disabled} onChange={this.onChange} style={{ minWidth: '0px' }} placeholder="Frequency" options={!this.props.limited ? select_options : limited_options}/>
      </div>
    );
  }
}

InputNumberFrequency.defaultProps = {
  disabled: false
}

InputNumberFrequency.propTypes = {
  // numValue: PropTypes.string.isRequired,
  // freqValue: PropTypes.string.isRequired,
  disabled:PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  inputNumberName: PropTypes.string.isRequired,
  inputFreqName: PropTypes.string.isRequired,
}

export default InputNumberFrequency;
